import React from "react";

export default function TrainingIcon() {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3702 50.6296L10.6641 53.4827L4.9551 50.6296V43.4913L10.6641 40.6354L16.373 43.4913L16.3702 50.6296ZM19.2261 64.9034V59.1944L10.6613 56.3358L2.09644 59.1916V64.9034H19.2261ZM42.0647 64.9034V59.1944L33.4999 56.3358L24.9351 59.1916V64.9006L42.0647 64.9034ZM64.9034 64.9034V59.1944L56.3357 56.3358L47.7709 59.1888V64.9006L64.9034 64.9034ZM39.2089 50.6296L33.4999 53.4827L27.7909 50.6296V43.4913L33.4999 40.6354L39.2089 43.4913V50.6296ZM62.0475 50.6296L56.3385 53.4827L50.6296 50.6296V43.4913L56.3385 40.6354L62.0475 43.4913V50.6296ZM53.3151 33.4999L56.3385 24.9351L51.0679 9.99968L33.4999 2.10205L15.9319 10.0025L10.6613 24.9379L13.6846 33.4999"
        fill="#35D7E4"
      />
      <path
        d="M53.3153 33.4999L56.3386 24.9351L51.068 9.99968L33.5 2.10205V33.4999H53.3153ZM16.3703 50.6296V43.4913L10.6642 40.6354V53.4827L16.3703 50.6296ZM10.6642 64.9034H19.2262V59.1944L10.6614 56.3358L10.6642 64.9034ZM39.209 50.6296V43.4913L33.5 40.6354V53.4827L39.209 50.6296ZM33.5 64.9034H42.0648V59.1944L33.5 56.3358V64.9034ZM62.0476 50.6296V43.4913L56.3386 40.6354V53.4827L62.0476 50.6296ZM56.3358 64.9034H64.9035V59.1944L56.3358 56.3358V64.9034Z"
        fill="#065B70"
      />
      <path
        d="M12.6378 19.2261H54.3229M12.6378 30.6441H54.3229M24.9351 5.95176V33.4999M42.0647 5.95176V33.4999M53.3151 33.4999L56.3385 24.9351L51.0679 9.99968L33.4999 2.10205L15.9319 10.0025L10.6613 24.9379L13.6846 33.4999M16.3702 50.6296L10.6641 53.4827L4.9551 50.6296V43.4913L10.6641 40.6354L16.373 43.4913L16.3702 50.6296ZM19.2261 64.9034V59.1944L10.6613 56.3358L2.09644 59.1916V64.9034H19.2261ZM42.0647 64.9034V59.1944L33.4999 56.3358L24.9351 59.1916V64.9006L42.0647 64.9034ZM64.9034 64.9034V59.1944L56.3357 56.3358L47.7709 59.1888V64.9006L64.9034 64.9034ZM39.2089 50.6296L33.4999 53.4827L27.7909 50.6296V43.4913L33.4999 40.6354L39.2089 43.4913V50.6296ZM62.0475 50.6296L56.3385 53.4827L50.6296 50.6296V43.4913L56.3385 40.6354L62.0475 43.4913V50.6296Z"
        stroke="url(#paint0_linear_98_1063)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_98_1063"
          x1="17.0322"
          y1="10.4506"
          x2="49.0368"
          y2="61.5593"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.125321" stopColor="#C8FBFF" />
          <stop offset="1" stopColor="#9AD7E4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
